import { AssociatedWith, IDocumentTable } from '@models/Document.model';

export function getAssociatedWithNameColor(document: IDocumentTable) {
  if (document.associatedWith === AssociatedWith.global) {
    return 'n700';
  }
  return 'n900';
}
